<template>
    <div class="page">
        <div class="page-text-wrap">
            <h1>De Farende Svende</h1>
            <img class="img-responsive" src="@/assets/info/farende-svend1.jpg" />
            <p>De farende svende dukker altid op til Vorbasse Marked. De lever et sparsomt liv på landevejen, hvor man gennem sommeren kan møde dem, oftest med en barnevogn med deres få ejendele i.</p>
            <p>I Vorbasse bor de i deres egen lille lejr og på markedspladsen kan de mødes i ølteltet eller rundt på pladsen, hvor de venligt spørger efter en lille mønt til en kop øl.</p>
            <img class="img-responsive" src="@/assets/info/farende-svend2.jpg" />
            <p>De kan ikke forestille sig en sommer uden Vorbasse Marked, men vi kan heller ikke forestille os et Vorbasse Marked uden dem.</p>
        </div>
    </div>
</template>

<script>
	export default {
		name: "DeFarendeSvende.vue"
	}
</script>
